import { LocaleTypes } from '@/App/types/LocaleTypes';

export const getLocalizedPathname = (pathname: string): string[] => {
  return [
    pathname,
    ...LocaleTypes.map((locale) => (pathname.endsWith('/') ? pathname + locale : `${pathname}/${locale}`)),
  ];
};
